<template>
  <form @submit.prevent="submitReason">
    <div class="mb-4">
      <va-input v-model="form.name" class="mb-0" placeholder="Повод" />
      <div
        v-if="!$v.form.name.required && $v.form.name.$error"
        class="error-message"
      >
        Обязательно для заполнения
      </div>
    </div>
    <div class="mb-3">
      <label for="icon-upload" class="custom-file-upload">
        Загрузить иконку
      </label>
      <input
        id="icon-upload"
        ref="fileInput"
        :disabled="selectedFile.length > 1"
        type="file"
        class="file-input"
        accept="image/x-png,image/jpg,image/jpeg,image/svg+xml"
        @input="onFilePicked($event)"
      />
    </div>
    <div class="mb-3" v-if="imageData.length > 0">
      <div
        v-for="(img, index) in imageData"
        :key="img.id"
        class="uploaded-file"
      >
        <img class="uploaded-file__img" :src="img.img_url" alt="icon" />
        <span
          ><va-button small @click.prevent="removeImg(index)">
            Удалить</va-button
          ></span
        >
      </div>
    </div>
    <va-button type="submit"> Добавить повод </va-button>
    <va-button @click="$emit('hide', false)"> Отменить </va-button>
  </form>
</template>

<script>
import api from "@/api/axios";
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
var slugify = require("slugify");
export default {
  name: "create-reason",
  data() {
    return {
      form: {
        name: "",
      },
      selectedFile: [],
      imageData: [],
    };
  },
  validations: {
    form: {
      name: {
        required,
      },
    },
  },
  methods: {
    ...mapActions({
      fetchReasons: "reason/getReasons",
    }),
    hide() {
      this.$emit("hide", false);
    },
    async submitReason() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      } else {
        try {
          let iconId = null;
          if (this.selectedFile.length > 0) {
            const formData = new FormData();
            formData.append("file[0]", this.selectedFile[0], this.selectedFile[0].name);
            const res = await api.post("/upload-file", formData);
            iconId = res.data[0].id;
          }
          
          await api.post("admin/reasons", {
            slug: slugify(this.form.name),
            name: this.form.name,
            icon_id: iconId,
          });
          this.fetchReasons();
          this.$emit("hide", false);
        } catch (error) {
          alert("Ошибка!");
          return error;
        }
      }
    },
    onFilePicked(event) {
      if (this.imageData.length >= 1) {
        alert("Максимум 1");
        return;
      }
      this.selectedFile.push(event.target.files[0]);
      const file = event.target.files;
      if (file && file[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageData.push({ img_url: e.target.result });
        };
        reader.readAsDataURL(file[0]);
      }
    },
    removeImg(imgId) {
      this.imageData.splice(imgId, 1);
      this.$refs.fileInput.value = "";
      this.selectedFile.splice(imgId, 1);
    },
  },
};
</script>
